import DeviceClientsPage, {
  ModalKeys as _ModalKeys,
} from "../../components/pages/device-clients";
import { useHistory, useLocation, useParams } from "react-router-dom";

export { _ModalKeys as ModalKeys };

function DeviceClients() {
  const history = useHistory();
  const location = useLocation();
  let { modal, clientId } = useParams<any>();
  const onShowModal = (key: _ModalKeys, dId?: string) => {
    let base: string | undefined;
    if (modal) {
      if (clientId) {
        base = location.pathname.replace(`/${clientId}/${modal}`, "");
      } else {
        base = location.pathname.replace(`/${modal}`, "");
      }
    } else {
      base = location.pathname;
    }
    if (base && base.endsWith("/")) {
      base = base.substr(0, base.length - 1);
    }
    if (dId) {
      history.push(`${base}/${dId}/${key}`);
    } else {
      history.push(`${base}/${key}`);
    }
  };
  const onHideModal = (callback?: () => void) => {
    if (clientId) {
      history.push(location.pathname.replace(`/${clientId}/${modal}`, ""));
    } else {
      history.push(location.pathname.replace(`/${modal}`, ""));
    }

    if (callback && typeof callback === "function") {
      callback();
    }
  };
  return (
    <DeviceClientsPage
      showModal={
        modal ? { key: modal as _ModalKeys, clientId: clientId } : undefined
      }
      onShowModal={onShowModal}
      onHideModal={onHideModal}
    />
  );
}
export default DeviceClients;
